export { default } from './InputArea.js';
